/**
 * AnnouncementsSection Component
 * 공지사항 섹션
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth, USER_TIERS } from '../../contexts/AuthContext';
import { useCommunity, POST_TYPES } from '../../contexts/CommunityContext';
import { formatDate } from './utils';
import CommunityEditor from '../../components/CommunityEditor';

const AnnouncementsSection = ({ onPostSelect }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { getAnnouncements, createPost } = useCommunity();

  const [showWriteForm, setShowWriteForm] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [newContent, setNewContent] = useState('');
  const [message, setMessage] = useState('');

  const isAdmin = user?.tier === USER_TIERS.ADMIN;
  const announcements = getAnnouncements();

  const handleCreatePost = (e) => {
    e.preventDefault();
    if (!newTitle.trim() || !newContent.trim()) return;

    createPost(POST_TYPES.ANNOUNCEMENT, newTitle, newContent, user, null, []);
    setNewTitle('');
    setNewContent('');
    setShowWriteForm(false);
    setMessage('공지사항이 등록되었습니다.');
    setTimeout(() => setMessage(''), 3000);
  };

  return (
    <div className="section-container">
      <div className="section-header">
        <h1>📢 {t('community.tabs.announcements', '공지사항')}</h1>
        <p>중요한 공지사항을 확인하세요</p>
      </div>

      {message && <div className="message success">{message}</div>}

      {isAdmin && !showWriteForm && (
        <button className="write-btn" onClick={() => setShowWriteForm(true)}>
          새 공지 작성
        </button>
      )}

      {showWriteForm && (
        <form onSubmit={handleCreatePost} className="write-form">
          <input
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            placeholder="공지사항 제목"
            required
          />
          <CommunityEditor
            value={newContent}
            onChange={setNewContent}
            placeholder="공지사항 내용"
            minHeight={200}
          />
          <div className="form-actions">
            <button type="button" onClick={() => setShowWriteForm(false)} className="cancel-btn">
              취소
            </button>
            <button type="submit" className="submit-btn">
              등록
            </button>
          </div>
        </form>
      )}

      <div className="posts-list">
        {announcements.length === 0 ? (
          <p className="no-posts">등록된 공지사항이 없습니다.</p>
        ) : (
          announcements.map((post) => (
            <div key={post.id} className="post-card" onClick={() => onPostSelect(post)}>
              <div className="post-card-header">
                <span className="post-badge announcement">공지</span>
                <h3>{post.title}</h3>
              </div>
              <div className="post-card-meta">
                <span className="author">{post.author.name}</span>
                <span className="date">{formatDate(post.createdAt)}</span>
                <span className="comments">댓글 {post.comments?.length || 0}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AnnouncementsSection;
